/**
 * Panel üst duyuru şeridinin sabitleri.
 *
 * Rotasyon süresi burada durur, bileşenin içinde değil: değeri değiştirmek
 * istediğinde tek yer, ayrıca testler aynı sabiti okuyup fake timer'ı ona
 * göre ilerletebiliyor.
 */

/** İki duyuru arasındaki bekleme süresi (ms). */
export const ANNOUNCEMENT_ROTATION_INTERVAL = 7000

/** Duyurular arası geçiş animasyonunun süresi (ms). */
export const ANNOUNCEMENT_FADE_DURATION = 420

/**
 * Şeritte aynı anda görünecek nokta sayısı. Duyuru sayısı bundan fazlaysa
 * yeni nokta EKLENMEZ; üçlü pencere aktif duyuruyu ortalayacak şekilde yana
 * kayar. Böylece 10 duyuruda da gösterge aynı yeri kaplar.
 */
export const ANNOUNCEMENT_DOT_WINDOW = 3

/** Nokta çapı ve aralığı (px) — kayma mesafesi bu ikisinden hesaplanır. */
export const ANNOUNCEMENT_DOT_SIZE = 7
export const ANNOUNCEMENT_DOT_GAP = 5

/** Duyuru listesinin arka planda tazelenme aralığı (ms) — 10 dakika. */
export const ANNOUNCEMENT_REFRESH_INTERVAL = 10 * 60 * 1000

/**
 * Önem derecesine göre vurgu rengi. Değerler CLAUDE.md'deki palete bağlı:
 * NAVY birincil, GREEN aktif/olumlu, ORANGE ikincil/uyarı.
 */
export const ANNOUNCEMENT_SEVERITY_COLORS = {
  INFO: "#221C5D",
  SUCCESS: "#71C30B",
  WARNING: "#E56A22",
}

/**
 * Duyuruda ikon belirtilmemişse önem derecesine göre kullanılacak boxicon.
 *
 * DİKKAT: projede boxicons paketten değil, `scss/plugins/icons/_boxicons.scss`
 * içine gömülü ESKİ bir setten (750 ikon) geliyor. Yeni boxicons sürümlerindeki
 * adlar (ör. bx-megaphone) burada YOK ve boş kare olarak çizilir. Yeni bir ikon
 * adı eklemeden önce o dosyada `.bx-<ad>:before` var mı diye bakın.
 */
export const ANNOUNCEMENT_DEFAULT_ICONS = {
  INFO: "bx-broadcast",
  SUCCESS: "bx-check-circle",
  WARNING: "bx-error",
}

/**
 * Duyuru oluşturma ekranındaki ikon seçicinin kataloğu.
 *
 * Gruplar yalnızca göz taraması içindir — hangi ikonun hangi önem derecesiyle
 * kullanılacağına dair bir kısıt YOK; her ikon her önem derecesiyle seçilebilir.
 * Listedeki adların tamamı `_boxicons.scss` içinde doğrulandı.
 */
export const ANNOUNCEMENT_ICON_GROUPS = [
  {
    label: "Duyuru",
    icons: ["bx-broadcast", "bx-bell", "bx-info-circle"],
  },
  {
    label: "Olumlu / Yenilik",
    icons: ["bx-check-circle", "bx-star", "bx-trending-up"],
  },
  {
    label: "Uyarı / Bakım",
    icons: ["bx-error", "bx-wrench", "bx-shield-quarter"],
  },
  {
    label: "Ürün",
    icons: ["bx-credit-card", "bx-receipt", "bx-purchase-tag"],
  },
]

/** Katalogdaki tüm ikonlar — doğrulama ve arama için düz liste. */
export const ANNOUNCEMENT_ICON_CHOICES = ANNOUNCEMENT_ICON_GROUPS.flatMap(g => g.icons)
